export default async function share(date: ShareData) {
  const can = navigator?.canShare?.(date);
  if (!can) return Promise.reject(null);
  return await navigator?.share?.(date);
}
